import { PageBody, PageHeader, SideNavigation } from '@components/organisms';
import { SideBar } from '@components/templates';
import React from 'react';

const PageWrapper = ({ children }: any) => {
  return (
    <>
      <PageHeader />
      <SideBar>
        <SideNavigation />
      </SideBar>
      <PageBody>{children}</PageBody>
    </>
  );
};

export default PageWrapper;
